export default __webpack_public_path__ + "static/media/icon-services-face-statistics.6e8c011b.svg";